import React from "react";
import { useParams } from "react-router-dom";
import MobileSecViewsHeader from "../../components/MobileSecViewsHeader";
import DesktopRegisterDetails from "../../components/DesktopRegisterDetails";

const MobileRegisterDetails = () => {
  const { id: selectedAccessId } = useParams<{
    id: string;
  }>();

  return (
    <div className="w-100 h-100 border-box p-8 scroll">
      {selectedAccessId && (
        <>
          <div className="mb-4">
            <MobileSecViewsHeader
              title={"Detalles de la visita"}
              route={"/logbook"}
            />
          </div>
          <DesktopRegisterDetails selectedAccessId={selectedAccessId} isMobile={true} />
        </>
      )}
    </div>
  );
};

export default MobileRegisterDetails;
